import { useRef } from "react";
import { useFrame } from "@react-three/fiber";

export default function FloatingBubbles({ count = 50 }) {
  const bubblesRef = useRef([]);

  useFrame(({ clock }) => {
    bubblesRef.current.forEach((bubble, i) => {
      if (!bubble) return;

      const time = clock.getElapsedTime();
      const speed = 0.5 + (i % 10) * 0.1;

      // Move bubbles upward with slight variation
      bubble.position.y += 0.015 * speed;

      // Reset position when bubble reaches top
      if (bubble.position.y > 5) {
        bubble.position.y = -5;
      }

      // Enhanced flowing side-to-side motion
      bubble.position.x += Math.sin(time * speed + i) * 0.002;
      bubble.position.z += Math.cos(time * speed * 0.8 + i) * 0.002;

      // Rotate and scale pulsing
      bubble.rotation.y += 0.015;
      const scale = 1 + Math.sin(time * 2 + i) * 0.1;
      bubble.scale.set(scale, scale, scale);
    });
  });

  return (
    <group>
      {Array.from({ length: count }).map((_, i) => {
        const size = Math.random() * 0.1 + 0.05;
        const x = (Math.random() - 0.5) * 20;
        const y = Math.random() * 10 - 5;
        const z = (Math.random() - 0.5) * 20 - 5;

        return (
          <mesh
            key={i}
            ref={(el) => (bubblesRef.current[i] = el)}
            position={[x, y, z]}
          >
            <sphereGeometry args={[size, 16, 16]} />
            <meshPhysicalMaterial
              transmission={0.98}
              thickness={0.15}
              roughness={0}
              color="#7ec8e3"
              transparent
              opacity={0.4}
              clearcoat={1}
              clearcoatRoughness={0}
            />
          </mesh>
        );
      })}
    </group>
  );
}
